import { render, staticRenderFns } from "./AssignV3.vue?vue&type=template&id=3902424b&scoped=true&"
import script from "./AssignV3.vue?vue&type=script&lang=js&"
export * from "./AssignV3.vue?vue&type=script&lang=js&"
import style0 from "./AssignV3.vue?vue&type=style&index=0&id=3902424b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3902424b",
  null
  
)

export default component.exports